import { render } from "./InicioPage.vue?vue&type=template&id=6444b8bc&scoped=true"
import script from "./InicioPage.vue?vue&type=script&lang=js"
export * from "./InicioPage.vue?vue&type=script&lang=js"

import "./InicioPage.vue?vue&type=style&index=0&id=6444b8bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6444b8bc"]])

export default __exports__